import { render, staticRenderFns } from "./PublisherInvites.vue?vue&type=template&id=523bb690"
import script from "./PublisherInvites.vue?vue&type=script&lang=js"
export * from "./PublisherInvites.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports